import { LoadingStates } from '@pb/utils'

import { NewsState } from './types'

const getNewsState = (state): NewsState => state?.account?.news

const getNews = (state): NewsState['news'] => getNewsState(state).news

const getShouldFetchNews = (state): boolean =>
  getNewsState(state).newsLoadingState === LoadingStates.NotLoaded

const getIsNewsLoading = (state): boolean =>
  getNewsState(state).newsLoadingState === LoadingStates.Loading

const getIsNewsFailed = (state): boolean =>
  getNewsState(state).newsLoadingState === LoadingStates.LoadedFail

const getIsNewsSuccess = (state): boolean =>
  getNewsState(state).newsLoadingState === LoadingStates.LoadedSuccess

export default {
  getNews,
  getShouldFetchNews,
  getIsNewsLoading,
  getIsNewsFailed,
  getIsNewsSuccess,
}
